var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1338_170796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1338_170796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 28V25.3333H6.66667V6.66667C6.66667 5.93333 6.92778 5.30556 7.45 4.78333C7.97222 4.26111 8.6 4 9.33333 4H22.6667C23.4 4 24.0278 4.26111 24.55 4.78333C25.0722 5.30556 25.3333 5.93333 25.3333 6.66667V25.3333H28V28H4ZM22.6667 25.3333V6.66667H9.33333V25.3333H22.6667ZM20 17.3333C20.3778 17.3333 20.6944 17.2056 20.95 16.95C21.2056 16.6944 21.3333 16.3778 21.3333 16C21.3333 15.6222 21.2056 15.3056 20.95 15.05C20.6944 14.7944 20.3778 14.6667 20 14.6667C19.6222 14.6667 19.3056 14.7944 19.05 15.05C18.7944 15.3056 18.6667 15.6222 18.6667 16C18.6667 16.3778 18.7944 16.6944 19.05 16.95C19.3056 17.2056 19.6222 17.3333 20 17.3333Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/Door.bc668c9fb77544114d043879bbe7db1b.svg";
export { ForwardRef as ReactComponent };